import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentFieldsVisibility } from './normalize';

export const fetchShipmentFieldsVisibility = createProvider(api.fetchShipmentFieldsVisibility)
  .andThen((res) => normalizeShipmentFieldsVisibility(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
